<script>
	import { autoGrow } from './autoGrow';
	// 스키마 fields로 입력 폼을 자동 생성. 콘텐츠 타입이 늘어도 이 컴포넌트는 그대로.
	// field.kind: 'text' | 'textarea' | 'url' | 'list'(item: 하위 fields)
	export let fields = [];
	export let data = {};       // 대상 객체 (양방향)
	export let onChange = () => {};

	const setVal = (key, val) => { data[key] = val; data = data; onChange(); };

	const ensureList = (key) => { if (!Array.isArray(data[key])) data[key] = []; };
	const addItem = (f) => { ensureList(f.key); data[f.key] = [...data[f.key], {}]; onChange(); };
	const removeItem = (f, i) => { data[f.key] = data[f.key].filter((_, idx) => idx !== i); onChange(); };
</script>

{#each fields as f}
	<div class="sf-row">
		<label class="sf-label">{f.label}</label>

		{#if f.kind === 'textarea'}
			<textarea rows="2" value={data[f.key] ?? ''} use:autoGrow={data[f.key]} on:input={(e) => setVal(f.key, e.target.value)}></textarea>
		{:else if f.kind === 'list'}
			<div class="sf-list">
				{#each (data[f.key] ?? []) as item, i}
					<div class="sf-list-item">
						<svelte:self fields={f.item} data={item} {onChange} />
						<button type="button" class="sf-mini del" on:click={() => removeItem(f, i)}>삭제</button>
					</div>
				{/each}
				<button type="button" class="sf-mini" on:click={() => addItem(f)}>+ 추가</button>
			</div>
		{:else}
			<input type={f.kind === 'url' ? 'url' : 'text'} value={data[f.key] ?? ''} on:input={(e) => setVal(f.key, e.target.value)} />
		{/if}
	</div>
{/each}

<style>
	.sf-row { display: flex; flex-direction: column; gap: 3px; margin-bottom: 6px; }
	.sf-label { font-size: 12px; color: hsl(var(--sb-muted-foreground)); }
	.sf-row input, .sf-row textarea {
		padding: 5px 7px;
		border: 1px solid hsl(var(--sb-border));
		border-radius: 5px;
		font-size: 13px;
		font-family: inherit;
		color: hsl(var(--sb-foreground));
		background: hsl(var(--sb-card));
		box-sizing: border-box;
	}
	.sf-row input:focus, .sf-row textarea:focus { outline: none; border-color: hsl(var(--sb-primary)); }
	.sf-list { display: flex; flex-direction: column; gap: 6px; padding-left: 8px; border-left: 2px solid hsl(var(--sb-border)); }
	.sf-list-item { display: flex; align-items: flex-start; gap: 6px; }
	.sf-list-item > :global(*:first-child) { flex: 1; }
	.sf-mini { align-self: flex-start; padding: 2px 8px; font-size: 12px; background: hsl(var(--sb-muted)); color: hsl(var(--sb-primary)); border: none; border-radius: 5px; cursor: pointer; }
	.sf-mini.del { background: hsl(var(--sb-destructive) / 0.15); color: hsl(var(--sb-destructive)); }
</style>
